import { IRootState } from 'affiny-core/modules/state';

export const selectCurrentPage = (state: IRootState): number =>
  state.photoReveals.meta.currentPage;

export const selectTotalItem = (state: IRootState): number | undefined =>
  state.photoReveals.meta.total;

export const selectPhotoRevealMemberIdList = (state: IRootState): string[] =>
  state.photoReveals.list;

export const selectShouldShowPhotoRevealSection = (
  state: IRootState
): boolean => state.photoReveals.list.length > 0 && state.subscription.isSub;
